<template>
 <div>
  <div class="home" >
    <div class="content">
      <div class="user-info">
        <div class="user-box">
          <div class="user-area">
            <div class="head-img" >
              <van-image :src="require('assets/imgs/avatar.png')" ></van-image>
            </div>
            <div class="user-content-login" v-if="user && user.nickName">
              <div class="user-name">昵称：{{ user.nickName }}</div>
              <div class="user-device">{{i18n.deviceNo}} : {{ deviceInfo? deviceInfo.devId : i18n.Unbound}}</div>
              <div class="user-device">{{i18n.expirationDate}} : {{invalidDate}}</div>
              <div class="user-device">{{i18n.DeviceState}} :
                <span class="user-device-unbound">{{cardOneRealStatus}}</span>
              </div>
            </div>
            <div class="user-content-unLogin" v-else @click="toLogin">{{i18n.Login_Register}}</div>
          </div>
        </div>
      </div>

      <div class="how-about" style="height: 160px;">
        <div style="padding: 20px;display: flex">
          <div style="width: 40%">
            <van-circle v-model="currentRate" :rate="percent" :stroke-width="120"
                        color="#1EBE86" layer-color="#1EBE8661" size="120px"/>
            <div style="margin: -85px 0 0 30px">
              <div style="color: #333333;font-family: MyFont8">剩余流量</div>
              <div style="color: #1EBE86;font-size: 12pt;margin: 1px 0 0 0px;font-family: MyFont6">{{ remainValue }}GB</div>
            </div>
          </div>
          <div style="width: 60%;">
            <div style="display: flex">
              <div class="data-item" style="font-family: MyFont6">
                <div>已用流量</div>
                <div style="margin-top: 5px">{{ pkgUsedCnt }}GB</div>
              </div>
              <div class="data-item" style="font-family: MyFont6">
                <div>总流量</div>
                <div style="margin-top: 5px">{{ pkgValue }}GB</div>
              </div>
            </div>
            <div style="display: flex;padding-top: 20px">
              <div class="data-item" style="font-family: MyFont6">
                <div>余额</div>
                <div style="margin-top: 5px">{{parseFloat(userData.userBalance).toFixed(2)}}</div>
              </div>
              <div class="data-item" style="font-family: MyFont6">
                <div>优惠券</div>
                <div style="margin-top: 5px">0/0</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu" style="height: 100px;display: flex;height: 80px">
        <div style="width: 50%;background: #1EBE86;margin-right: 10px;display: flex;border-radius: 11px" @click="rechargeClick">
          <div>
            <van-image class="backgroud-img" :src="require('assets/imgs/mifi15.png')" width="90px" height="80px"></van-image>
          </div>
          <div style="color: white;font-family: MyFont6;font-size: 14pt;margin-top: 30px;">
            <label>余额充值</label>
          </div>
        </div>
        <div style="width: 50%;background: #1EBE86;display: flex;border-radius: 11px" @click="productClick">
          <div>
            <van-image class="backgroud-img" :src="require('assets/imgs/mifi16.png')" width="90px" height="80px"></van-image>
          </div>
          <div style="color: white;font-family: MyFont6;font-size: 14pt;margin-top: 30px;">
            <label>套餐充值</label>
          </div>
        </div>
      </div>
      <div class="menu">
        <div class="listT">
          <div class="item" @click="addEquipment">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/mifi06.png')" width="40px" height="40px"></van-image>
            </div>
            <div class="desc">新增设备</div>
          </div>
          <div class="item" @click="toOrder">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/mifi02.png')" width="40px" height="40px"></van-image>
            </div>
            <div class="desc">已购套餐</div>
          </div>
          <div class="item" @click="toSwitchCard">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/mifi03.png')" width="40px" height="40px"></van-image>
            </div>
            <div class="desc">网络切换</div>
          </div>
          <div class="item" @click="check" >
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/mifi05.png')" width="40px" height="40px"></van-image>
            </div>
            <div class="desc">网络检测</div>
          </div>
        </div>
        <div class="listT ext" style="display: none">
          <div class="item" @click="toCertify" >
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/mifi01.png')" width="40px" height="40px"></van-image>
            </div>
            <div class="desc">实名认证</div>
          </div>
          <div class="item">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/mifi07.png')" width="30px" height="30px"></van-image>
            </div>
            <div class="desc">关注公众号</div>
          </div>
          <div class="item">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/mifi04.png')" width="30px" height="30px"></van-image>
            </div>
            <div class="desc">常见问题</div>
          </div>
          <div class="item">
            <div>
              <van-image class="backgroud-img" :src="require('assets/imgs/mifi08.png')" width="30px" height="30px"></van-image>
            </div>
            <div class="desc">联系客服</div>
          </div>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>
<script>
import { mapState } from 'vuex'
import { MIFI_DEVICE, MIFI_DEVICE_INFO, MIFI_DEVICE_PKG } from '@/apis/cabinet'
import { USER_INFO } from '@/apis/user'
import dayjs from 'dayjs'
import router from "@/router";
export default {
  components: {
  },
  data () {
    return {
      list: [],
      item: null,
      show: false,
      methodShow: false,
      methodScanShow: false,
      isMenuView: false,
      ishomeSearch: false,
      searchText: '',
      percent: 80,
      currentRate: 100,
      packageObj: {
        skuId: 0
      },
      packageDtlList: [],
      deviceInfo: null,
      deviceItems: [],
      isPickUpShow: false,
      orderList: [],
      typeMap: {},
      startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      endTime: '',
      packageCount: 1,
      packageName: '',
      remainValue: 0,
      pkgUsedCnt: 0,
      pkgValue: 0,
      cardOneRealStatus: '未实名',
      invalidDate: null,
      userData: {
        userBalance: 0
      }
    }
  },
  computed: {
    ...mapState(['user', 'token', 'browser', 'qrcode', 'mifisn']),
    i18n () {
      return this.$t('home')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    i18nActivation() {
      return this.$t('activation')
    }
  },
  watch: {
    latLng () {
      this.lazyLoad(this)
    }
  },
  methods: {
    toLogin() {
      this.$router.push('/login_wechat')
    },
    deviceManagement() {
      this.$router.push('/deviceManager')
    },
    productClick() {

      this.$router.push('/product')
    },
    toOrder() {
      this.$router.push('/order')
    },
    toSwitchCard() {
      this.$router.push('/switchCard')
    },
    toCertify() {
      this.$router.push('/certify')
    },
    rechargeClick() {
      this.$router.push('/recharge')
    },
    addEquipment() {
      // this.$router.push('/activityDevice')
      this.$router.push('/deviceManager')
    },
    check() {
      this.$router.push('/check')
    },
    deviceList() {
      this.$post(
        MIFI_DEVICE, {}, (resp) => {
          this.deviceItems = resp.data
          if (this.deviceItems.length === 0) {
            this.$router.push('/activityDevice')
            return
          }
          for (var i = 0; i < this.deviceItems.length; i++) {
            if (this.deviceItems[i].isDefault === 1) {
              this.deviceInfo = this.deviceItems[i]
              this.$store.commit('mifisn', this.deviceInfo.devId)
              this.loadPkg(this.deviceInfo.devId)
              this.deviceInfoById(this.deviceInfo.devId)
            }
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    loadPkg(devId) {
      this.$post(
        MIFI_DEVICE_PKG, {
          devId: devId
        }, (resp) => {
          if (resp.data) {
            this.pkgUsedCnt = resp.data.pkgUsedCntT
            this.remainValue = resp.data.remainValueT
            this.pkgValue = resp.data.pkgValueT
            this.percent = (resp.data.pkgUsedCntT / resp.data.pkgValueT) * 100
            this.invalidDate = resp.data.invalidDate
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    deviceInfoById(devId) {
      this.$post(
        MIFI_DEVICE_INFO, {
          devId: devId
        }, (resp) => {
          if (resp.data) {
            if (resp.data.data.online === 0) {
              this.cardOneRealStatus = '离线'
            } else if (resp.data.data.online === 1) {
              this.cardOneRealStatus = '在线'
            } else if (resp.data.data.online === 3) {
              this.cardOneRealStatus = '已拿卡'
            } else if (resp.data.data.online === 4) {
              this.cardOneRealStatus = '拿卡失败'
            } else if (resp.data.data.online === 5) {
              this.cardOneRealStatus = '正在拨号'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '下线'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '本地卡在线'
            }
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    loadUser() {
      this.$post(
        USER_INFO,
        {},
        res => {
          if (res.data) {
            this.userData = res.data
            this.$store.commit('user', res.data)
          }
        },
        err => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
          //  this.$store.commit('token', null)
          })
        }
      )
    }
  },
  created () {
    console.log(this.token)
    if (this.token) {
      this.loadUser()
    } else {
      this.$router.replace('/login_wechat')
    }
    if (this.user) {
      this.deviceList()
    }
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
.home{
  position: relative;
  display: flex;
  .home-left{
    position: fixed;
    top: 96px;
    left: 40px;
    z-index: 1;
  }
}
.google-map{
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  overflow: hidden;
}
.content{
  width: 100%;
}
.user-info{
  width: 100%;
  border-radius: 15px;
  .head-img{
    width: 147px;
    height: 147px;
    background: #E9E9E9;
    border-radius: 50%;
    margin: 40px;
  }
  .user-box{
    background-image: url("../../assets/imgs/img_dollar-ext.png");
    background-size: cover;
    background-position: center;
  }
  .user-area{
    display: flex;
  }
  .backgroud-img{
    position: fixed;
    top: 0;
    z-index: -1;
  }
  .user-content-unLogin{
    font-family: MyFont1;
    font-size: 36px;
    color: #FFFFFF;
    font-weight: Bold;
    //align-content: center;
    margin-top: 85px;
  }
  .user-content-login{
    color: #FFFFFF;
    //align-content: center;
    margin-top: 25px;
    font-family: MyFont2;
  }
  .user-name{
    font-size: 36px;
    padding-bottom: 20px;
    font-weight: bold;
  }
  .user-device{
    font-size: 24px;
    padding-bottom: 20px;
  }
  .user-device-unbound{
    font-family: MyFont2;
    font-weight: 400;
    font-size: 16px;
    color: #1EBE86;
    background: #ffffff;
    padding: 5px 10px 5px 10px;
    border-radius: 16px;
  }
}
.how-about{
  background: #FFFFFF;
  box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.08);
  border-radius: 18px 18px 18px 18px;
  margin: 20px;
  .how-use{
    font-family: MyFont1;
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    text-align: center;
    padding: 20px;
  }
  .refueling{
    display: flex;
  }
  .pack{
    font-family: MyFont3;
    font-weight: bold;
    font-size: 24px;
    color: #1EBE86;
    font-weight: bold;
    text-align: right;
    width: 50%;
    padding: 15px 20px 0 0;
  }
}
.data-item{
  width: 50%;
  text-align: center;
  color: #333333;
  font-family: MyFont2;
}
.menu{
  background: #FFFFFF;
  box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.08);
  border-radius: 18px 18px 18px 18px;
  margin: 20px;
  .item{
    width: 25%;
    text-align: center;
    padding: 30px 0 0 0;
  }
  .listT{
    display: flex;
    padding: 0 0 30px 0;
    margin: 0;
  }
  .desc{
    font-family: MyFont8;
    font-size: 24px;
    color: #333333;
  }
  .ext{
    padding-bottom: 30px;
  }
}
.tip{
  font-family: MyFont4;
  font-weight: 300;
  font-size: 22px;
  color: #666666;
  text-align: center;
  padding: 20px;
}
.pakage-box {
  margin: 20px;
  position: relative;
  // width: 100%;
  background: #FFFFFF;
  border-radius: 18px 18px 18px 18px;
  border: 1px solid #D1D1D1;
  padding: 17px 20px;
  .pakage-text{
    width: 70%;
    font-family: MyFont2;
    font-weight: bold;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
  }
  .pakage-price {
    font-family: MyFont3;
    font-size: 30px;
    font-weight: bold;
    color: #FF1919;
  }
}
.bottom-pakage-btn{
  font-weight: 400;
  font-size: 24px;
  color: #1EBE86;
  width: 280px;
  height: 76px;
  border-radius: 40px 40px 40px 40px;
  margin: 30px;
  border: 2px solid #1EBE86;
}
.h-pakage {
  border: 3px solid #00AB46;
}
.fixed{
  position: fixed;
  bottom: 0;
  width: 100%;
  // background: rgba(45, 45, 45, 0.5);
  height: 100%;
}
</style>>
